import React from "react";
/* Die Spalte trägt das Raster, nicht die einzelne Zeile: ein Grid aus Labelspalte
   und fester Steuerspalte; die Zeilen laufen als display:contents darin. So stehen
   alle Felder einer Spalte auf einer Kante und sind gleich breit. */
export function FormGrid({ children, labelWidth, controlWidth, style = {} }) {
  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "minmax(0,1fr) " + (controlWidth || "var(--grid-control-col)"),
      alignItems: "center", columnGap: 12, rowGap: 9,
      ["--grid-label-col"]: labelWidth || undefined, ...style,
    }}>{children}</div>
  );
}

/* Die Beschriftung wird zum <label>, sobald sie ein Ziel hat: dann springt ein Klick
   darauf in das Feld, und ein Screenreader liest sie zu dem Feld. Ohne Ziel bleibt es
   ein <span> — ein <label htmlFor> ins Leere wäre schlechter als gar keines.
   Die Stile stehen einmal in labelStyle und nicht zweimal abgeschrieben: Es wird immer
   nur einer der beiden Zweige gezeichnet, ein Auseinanderlaufen sähe niemand. */
export function FormRow({ label, htmlFor, children, hint, full = false }) {
  if (full) return <div style={{ gridColumn: "1 / -1" }}>{children}</div>;
  const labelStyle = { fontSize: "var(--type-label-size)", color: "var(--fg-4)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
  return (
    <div style={{ display: "contents" }}>
      {htmlFor
        ? <label htmlFor={htmlFor} title={label} style={labelStyle}>{label}</label>
        : <span title={label} style={labelStyle}>{label}</span>}
      <div style={{ minWidth: 0 }}>
        {children}
        {hint ? <div style={{ paddingTop: 3, fontSize: "var(--fs-11)", color: "var(--fg-8)" }}>{hint}</div> : null}
      </div>
    </div>
  );
}
